import { render, staticRenderFns } from "./ToastFactory.vue?vue&type=template&id=06ee97d4"
import script from "./ToastFactory.vue?vue&type=script&lang=js"
export * from "./ToastFactory.vue?vue&type=script&lang=js"
import style0 from "./ToastFactory.vue?vue&type=style&index=0&id=06ee97d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports